module.exports = {"350521100":"螺城镇","350521101":"螺阳镇","350521102":"黄塘镇","350521103":"紫山镇","350521104":"洛阳镇","350521105":"东园镇","350521106":"张坂镇","350521107":"崇武镇","350521108":"山霞镇","350521109":"涂寨镇","350521110":"东岭镇","350521111":"东桥镇","350521112":"净峰镇","350521113":"小岞镇","350521114":"辋川镇","350521200":"百崎回族乡","350521400":"城南工业区","350521401":"惠南工业区","350521402":"泉惠石化工业园区","350521403":"惠东工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350521.json
// module id = 1312
// module chunks = 0